module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "chart-container",
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dboard_report')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')) + ":" + _vm._s(_vm.time))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh1': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "width": "94%",
      "margin": "10px auto"
    }
  }, [_vm._v(_vm._s(_vm.$t("dboard_glucose_statistics")))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_glucose')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_cgm')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_insulin')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_carbs')))]), _vm._v(" "), _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_exercise')))])]), _vm._v(" "), _c('tr', {
    staticClass: "trh1"
  }, [_c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_glucose_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_cgm_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_insulin_avg')))]), _vm._v(" "), _c('td', {
    staticClass: "rb ",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_carbs_avg')))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_exercise_avg')))])]), _vm._v(" "), _c('tr', {
    staticClass: "trh1"
  }, [_c('td', {
    staticClass: "rb bb sp",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.bgAvg))]), _vm._v(" " + _vm._s(_vm.glucoseUnit))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.sgAvg))]), _vm._v(" " + _vm._s(_vm.glucoseUnit))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.insAvg))]), _vm._v(" " + _vm._s(_vm.$t('ins_unit2')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.carbAvg))]), _vm._v(" g")]), _vm._v(" "), (_vm.exerAvgHour == 0) ? _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvg))]), _vm._v(_vm._s(_vm.$t('t1112_min')))]) : _c('td', {
    staticClass: "bb",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvgHour))]), _vm._v(_vm._s(_vm.$t('Hours')) + "   "), _c('span', {
    staticClass: "bbv"
  }, [_vm._v(_vm._s(_vm.exerAvg))]), _vm._v(" " + _vm._s(_vm.$t('t1112_min')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('t1112_days')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_sd')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_num')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.bgSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.bgNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.sgSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.sgNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.insSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.insNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.carbSD))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.carbNum))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.exerSD))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.exerNum))])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "est-a1c"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "est-title"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t1")))]), _vm._v(" "), (_vm.a1c_available) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.est_a1c) + "  ")]), _c('span', [_vm._v(_vm._s(_vm.$t("est_a1c_t2")))])]) : _c('span', [_c('span', [_vm._v(_vm._s(_vm.$t('t1112_Not_available')))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "x_est-ita"
  }, [_vm._v(_vm._s(_vm.$t("est_a1c_t3")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph2",
    attrs: {
      "id": "chart1_4"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "id": "img1_1"
    }
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "left-table"
  }, [_c('p', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_statistics')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_BG')))]), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_BG_calibration')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.bgPerDay) + " / " + _vm._s(_vm.calibPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_SG')))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_AUC_high')) + " " + _vm._s(_vm.highLevelText))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.aucu))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_AUC_low')) + " " + _vm._s(_vm.lowLevelText))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.aucl))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_highest_value')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.sgHighest))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_lowest_value')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.sgLowest))])])]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_pump')))]), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_daily_basal')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.basalPercent))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_daily_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.bolusPercent))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_bolus_num')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgBolusNum))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb bb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_suspend_time')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgSuspendTime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('dboard_avg_reservoir_usage')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.patchAvgLife) + " " + _vm._s(_vm.$t('t1113_days')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-chart"
  }, [_c('div', {
    attrs: {
      "id": "chart1_5"
    }
  }, [_c('img', {
    staticClass: "img",
    class: {
      'hide': _vm.chart5NoData
    },
    attrs: {
      "id": "img1_2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart5NoData
    }
  }, [_vm._v("Overall: Time In Range")]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart5NoData
    },
    attrs: {
      "id": "chart1_5_no_data"
    }
  }, [_vm._v("No data")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row2 left-table"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_manual_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_normal')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualNormalBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_extend')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgManualExtendBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_combo')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgManualComboBolus))])])]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_bolus_calculator')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_food_bolus')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgFoodWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_corr_bolus')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgCorrWizzardBolus))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb bb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_override_add')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.avgWizzardOverrideAdd))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('dboard_override_sub')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.avgWizzardOverrideSub))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row2 right-chart",
    attrs: {
      "id": "chart1_6"
    }
  }, [_c('img', {
    staticClass: "img",
    class: {
      'hide': _vm.chart6NoData
    },
    attrs: {
      "id": "img1_3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart6NoData
    }
  }, [_vm._v(" Basal & Bolus")]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart6NoData
    },
    attrs: {
      "id": "chart1_6_no_data"
    }
  }, [_vm._v("No data")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "row1"
  }, [_c('div', {
    staticClass: "left-table"
  }, [_c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_in_Auto_Mode')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.timeInAutoMode))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Average_SG_SD')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGAvgSD) + " " + _vm._s(_vm.glucoseUnit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_in_Target_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGInTargetRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_above_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGAboveRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Time_below_Range')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeSGBelowRange))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: " rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Basal_per_day')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeBasalPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "bb rb",
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Bolus_per_day')))]), _vm._v(" "), _c('td', {
    staticClass: "bb"
  }, [_vm._v(_vm._s(_vm.autoModeBolusPerDay))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Auto_Mode_Exits')))]), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_No_Sensor_readings')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseNoSensorReadings))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Max_Delivery')) + " ")]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseMaxDelivery))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rb"
  }), _vm._v(" "), _c('td', {
    staticClass: "rb"
  }, [_vm._v(_vm._s(_vm.$t('t1221_Min_Delivery')))]), _vm._v(" "), _c('td', {}, [_vm._v(_vm._s(_vm.autoModeExitCauseMinDelivery))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-chart"
  }, [_c('img', {
    staticClass: "img",
    class: {
      'hide': _vm.chart7NoData
    },
    attrs: {
      "id": "img1_4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chart_title",
    class: {
      'hide': _vm.chart7NoData
    }
  }, [_vm._v(" Auto Mode: Time In Range")]), _vm._v(" "), _c('p', {
    class: {
      'hide': !_vm.chart7NoData
    },
    attrs: {
      "id": "chart1_7_no_data"
    }
  }, [_vm._v("No data")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5983067a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/chart0_print.vue
// module id = 1469
// module chunks = 7